export async function ensureWebsocketDefined(): Promise<void> {
  if (typeof global !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const g: any = global;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (typeof g.WebSocket === 'undefined') {
      const { WebSocket: NodeWebSocket } = await import('ws');

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      g.WebSocket = NodeWebSocket;
    }
  }
}
